import { c as _c } from "react/compiler-runtime";
import { Image } from '@/app/components/media/image';
import type { ProductBaseProps } from '@/app/cv/components/sections/products/types';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { stripHtmlTags } from '@/app/utils/format';
type SlideImageProps = Pick<ProductBaseProps, 'image' | 'title'>;
export const SlideImage = t0 => {
  const $ = _c(6);
  const {
    title,
    image
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createDataAttributes({
      test: "content-image"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = image?.src ?? "";
  const t3 = image?.alt ?? title ?? "";
  let t4;
  if ($[1] !== t3) {
    t4 = stripHtmlTags(t3);
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t4) {
    t5 = <div className="rounded-base-md overflow-hidden" {...t1}><Image src={t2} alt={t4} width={640} height={360} aspectRatio="aspect-16-9" sizes="(min-width: 1024px) 50vw, 100vw" /></div>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};